import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { GalleryCollectionComponent } from '../gallery-collection.component';
import { LightboxModule } from 'ngx-lightbox';

@Component({
  selector: 'app-gallery-dashboard',
  standalone: true,
  imports: [RouterLink, AccordionModule, AsyncPipe, NgForOf, NgIf, LightboxModule],
  templateUrl: './gallery-dashboard.component.html',
  styles: ``,
})
export class GalleryDashboardComponent extends GalleryCollectionComponent {}
